import React from 'react'

function ResumeDetail({title,children,classname,position}) {
  return (
    <>
    <div className={`resumeDetail ${classname}`}>
        <div className='resumeDetail-heading'>
            <p className={`font-bold border-b-2 border-solid ${position === 'left' ? 'border-white' : 'border-black'}`}>{title}</p>
        </div>
        {children}
    </div>
    </>
  )
}

export default ResumeDetail